<div class="header">
  <p>Mi CLABE</p>
  <img (click)="close()" class="my-auto" height="13" src="assets/icon/x.svg" alt="close">
</div>
<div class="body fs-body">
  <p>Te otorgamos una CLABE personalizada para depositar dinero a tu cuenta Monific desde tu banca personal en línea.
  </p>

  <div class="container-clabe">
    <div class="d-flex justify-content-between mb-2">
      <div>
        <p class="mb-0 fw-sbold cl-primary-3">CLABE</p>
        <p class="mb-0 fw-sbold info">{{ clabe }}</p>
      </div>
      <img (click)="copyClabe()" height="20" class="my-auto" src="assets/icon/copy.svg" alt="">
    </div>

    <div class="mb-2">
      <p class="mb-0 fw-sbold cl-primary-3">Beneficiario</p>
      <p class="mb-1 cl-neutral-3">{{ name }}</p>
    </div>

    <div>
      <p class="mb-0 fw-sbold cl-primary-3">Banco receptor</p>
      <p class="mb-0 cl-neutral-3">STP</p>
    </div>
  </div>

  <div class="w-100 text-center">
    <button mat-button (click)="openInstructions()">Instrucciones</button>
  </div>

</div>
